<div class="ecom-page-container ecom-auctions-list-container">
  <div *ngIf="_isUndefined(_auctions) || _auctions.length === 0">
    You have not bid on any auctions
  </div>
  <div *ngFor="let auction of _auctions">
    <af-row-item (onImageClick)="_goToDetail(auction)"
                 (onTitleClick)="_goToDetail(auction)"
                 [auction]="auction"></af-row-item>
  </div>
</div>